<template>
  <div class="cover pt-5">
    <div class="net-graph-close">
        <img src="@/assets/net-img.png" />
    </div>
    <div class="meta text-center">
      
      <div>        
        <div class="row justify-content-center">
          <div class="col-md-7 col-12 col-lg-5">
            <div class="headline pt-5 mt-3">
              <h1 v-html="$t('cover.title')"></h1>
            </div>
          </div>          
        </div>

      </div>
    </div>

    <div class="video-cover">
      <div>
        <div class="frame">
          <div class="video">
            <div class="btn-audio">
              <span>
                <button @click="showVideo()" class="btn btn-danger">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-volume-up-fill" viewBox="0 0 16 16">
                    <path d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"/>
                    <path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"/>
                    <path d="M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06"/>
                  </svg> Activar audio
                </button></span> 
            </div>
            <div class="btn-audio-small">
                <button @click="hideVideo()" class="btn btn-danger">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-volume-mute-fill" viewBox="0 0 16 16">
                    <path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06m7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0"/>
                  </svg>
                </button>
            </div>
            <video id="video-cover-fabrica" muted autoplay loop src="/wp-content/interactivos/factchecking-loreto/videos/intro.mp4" />
          </div>
        </div>
      </div>
    </div>
    <div class="meta text-center">
      
      <div>        
        <div class="row justify-content-center pb-5 mb-5">
          <div class="col-12 col-md-8 col-lg-7 col-xl-6 text-center">            
            <div class="excerpt">
              <Contenido/>
            </div>
            <div>
              <button @click="openVideoMiniDoc()" class="btn-minidoc">Ver minidocumental</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="scroll-container">
      <div class="text-scroll">Scroll para continuar <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-mouse" viewBox="0 0 16 16">
        <path d="M8 3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 3m4 8a4 4 0 0 1-8 0V5a4 4 0 1 1 8 0zM8 0a5 5 0 0 0-5 5v6a5 5 0 0 0 10 0V5a5 5 0 0 0-5-5"/>
      </svg></div>
    </div>
	</div>
</template>

<style lang="scss">

  @keyframes slideDownArrow {
    from {
      opacity: 1;
      bottom: 100px;
    }

    to {
      opacity: 0;
      bottom: 0px;
    }
  }

  .cover .btn-audio {
    position: absolute;
    top: 45%;
    width: 100%;
    text-align: center;
    z-index: 999;
    color: #fff;
    animation: blinker 2.5s linear infinite;

    .btn {
      margin: 0 2px;
      padding: 3px;
      border-radius: 0;
      font-size: 15px;
      font-weight: 600;
    }

    &.active {
      display: none;
      pointer-events: none;
    }
  }

  .net-graph-close {
    position: absolute;
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    top: 0%;
    left: 0;

    img {
      display: block;
      width: 100%;
      height: 200vh;
      margin: 0 auto;
      opacity: 0.7;
      object-fit: cover;
    }
  }

  .net-graph-open {
    width: 100%;
    max-width: 820px;
    margin: 0 auto;

    img {
      opacity: 0.8;
    }
  }


  .btn-audio-small {
    position: absolute;
    right: 0;
    padding: 15px;
    opacity: 0;
    z-index: 90;
    display: none;

    &.active {
      opacity: 1;
      display: block;
      pointer-events: all;
    }

    .btn {
      margin: 0 2px;
      padding: 3px;
      border-radius: 0;
    }

    
  }

  .container-logo {
    position: relative;
    width: 100%;
    z-index: 1;
  }

  .btn-minidoc {
    margin: 15px 0;
    color: #000;
    background-color: #fff;
    border: none;
    padding: 10px 15px;
    font-weight: 400;
    font-size: 15px;
    font-family: "Nunito";
    text-transform: uppercase;

    &:hover {
      background-color: #e3e3e3;
    }
  }

</style>

<script>

  import Contenido from '@/components/Contenido'
  
  export default {
    name: 'CoverHome',
    components: {
      Contenido
    },
    data: () => ({
      popUp: false
    }),
    methods: {
      togglePopUp(){
        this.popUp = !this.popUp
      },
      openVideoMiniDoc() {
        document.querySelector(`#foco_video_minidoc_item`).scrollIntoView({ block: "center", inline: "nearest" })
      },
      showVideo() {
        document.querySelector(`#video-cover-fabrica`).muted = false
        document.querySelector(`#video-cover-fabrica`).style.opacity = 1
        document.querySelector(`.btn-audio`).classList.add(`active`)
        document.querySelector(`.btn-audio-small`).classList.add(`active`)
      },
      hideVideo() {
        document.querySelector(`#video-cover-fabrica`).muted = true
        document.querySelector(`#video-cover-fabrica`).style.opacity = 0.4
        document.querySelector(`.btn-audio`).classList.remove(`active`)
        document.querySelector(`.btn-audio-small`).classList.remove(`active`)
      }
    }
  }
</script>
